import React from "react";
import { Button } from "@/components/common/Button";
import { CloseIcon } from "@/components/common/icons/CloseIcon";
import { SettingsIcon } from "@/components/common/icons/SettingsIcon";
import { MicIcon } from "@/components/common/icons/MicIcon";
import { DownloadIcon } from "@/components/common/icons/DownloadIcon";
import { useBot } from "@/api/useBot";
import { MicCrossedIcon } from "@/components/common/icons/MicCrossedIcon";
import Link from "next/link";
import { isProfessionalBot } from "@lango/api/src/queries/bot/bot";

import styles from "./ChatHeader.module.css";

type Props = {
  voiceMode?: boolean;
  onSettings?: () => void;
  onMic?: () => void;
  onDownload?: () => void;
};

export const ChatHeader: React.FC<Props> = ({
  voiceMode,
  onSettings,
  onMic,
  onDownload,
}) => {
  const { data: bot } = useBot();
  const backUrl = bot?.id
    ? isProfessionalBot(bot.id)
      ? "/professional-english"
      : "/"
    : "/";

  return (
    <div className={styles.container}>
      <Link href={backUrl} className={styles.xButton}>
        <CloseIcon />
      </Link>
      <div className={styles.leftWrap}>
        <img
          src={bot ? `/botsProfiles/${bot.avatar}.png` : undefined}
          alt={""}
          className={styles.avatar}
        />
        <div className={styles.name}>IA Chat</div>
      </div>
      <div className={styles.rightWrap}>
        {onDownload && (
          <Button
            onClick={onDownload}
            variant="clean"
            className={styles.download}
            title="Download conversation as PDF"
          >
            <DownloadIcon className={styles.downloadIcon} />
          </Button>
        )}
        {onSettings && (
          <Button
            onClick={onSettings}
            variant="clean"
            className={styles.settings}
          >
            <SettingsIcon />
          </Button>
        )}
        {onMic && (
          <Button onClick={onMic} variant="clean" className={styles.mic}>
            {voiceMode ? (
              <MicCrossedIcon className={styles.crossedMic} />
            ) : (
              <MicIcon className={styles.micIcon} />
            )}
          </Button>
        )}
      </div>
    </div>
  );
};
